import React from 'react';
import jet from "@randajan/jet-react";

import "./WebLink.scss";
import { Link } from '@randajan/jet-react/dom/link';
import { ImgStore } from '../ImgStore/ImgStore';

export const WebLink = (props)=>{
    const { link } = props;
    const { title, webImg, url } = link;
    
    return (
        <div className={"WebLink"}>
            <Link to={url} className="linkIcon" draggable="false">
                <ImgStore src={`${webImg}.png`}/>
            </Link>
            <Link to={url} className="linkTitle" draggable="false">
                <span>{title}</span>
            </Link>
        </div>
    )
}

